module.exports = __webpack_public_path__ + "img/mute.e0c09975.svg";